const dataAttributes = {
  CART_CONTAINER: 'data-flow-cart-container',
  CART_DISCOUNT_AMOUNT: 'data-flow-cart-discount-amount',
  CART_DISCOUNT_CURRENCY: 'data-flow-cart-discount-currency',
  CART_ITEM_NUMBER: 'data-flow-cart-item-number',
  CART_ITEM_QUANTITY: 'data-flow-cart-item-quantity',
  CART_ITEM_DISCOUNT_AMOUNT: 'data-flow-cart-item-discount-amount',
  CART_ITEM_DISCOUNT_CURRENCY: 'data-flow-cart-item-discount-currency',
  CART_ITEM_DISCOUNT_PERCENT: 'data-flow-cart-item-discount-percent',
  DATA_CART_ITEM_COMPARE_AT: 'data-flow-cart-compare-at',
  ITEM_NAME: 'data-flow-item-name',
  ITEM_NUMBER: 'data-flow-item-number',
  ITEM_FLOW_VARIANT: 'flow-variant',
  ITEM_AVAILABILITY_STATUS: 'flow-variant-inventory',
  ITEM_PRICE_ATTRIBUTE_KEY: 'data-flow-item-price-attribute',
  ITEM_ATTRIBUTE_KEY: 'data-flow-item-attribute-key',
  ITEM_ATTRIBUTE_VALUE: 'data-flow-item-attribute-value',
  ITEM_TAX_AND_DUTY_MESSAGE: 'item-tax-duty-message',
  CLIENT_SCHEMA: 'script[type="application/vnd.flow.ld+json"]',
  LD_JSON_SCHEMA: 'script[type="application/ld+json"]',
  LOCALIZE: 'data-flow-localize',
  PRICE_FACET_AMOUNT_ATTRIBUTE: 'data-flow-price-facet-amount-attribute',
  PRICE_FACET_BOUNDARY: 'data-flow-price-facet-boundary',
  PRICE_FACET_CURRENCY: 'data-flow-price-facet-currency',
};

const misc = {
  CHECKOUT_DOMAIN: 'checkout.flow.io',
  FLOW_API_HOST: 'https://api.flow.io',
  ITEM_PRICE: 'item-price',
  ITEM_PRICE_ATTRIBUTE: 'item-price-attribute',
  CLASS_FLOW_ACCEPTED_PAYMENT_METHODS: 'flow-accepted-payment-methods',
};

const cart = {
  CART_JSON_CONTAINER_ID: 'flow_shopify_cart',
  CART_CONSUMED_ATTR_NAME: 'data-flow-consumed',
  CART_ITEM_PRICE: 'cart-item-price',
  CART_ITEM_LINE_TOTAL: 'cart-item-line-total',
  CART_ITEM_COMPARE_AT: 'cart-item-compare-at',
  CART_SUBTOTAL: 'cart-subtotal',
  CART_TOTAL: 'cart-total',
  CART_TAX_NAME: 'cart-tax-name',
  CART_TAX: 'cart-tax',
  CART_DUTY: 'cart-duty',
  CART_DISCOUNT: 'cart-discount',
  CART_SHIPPING: 'cart-shipping',
  CART_LOADING_CLASS: 'flowcalizing',
};

export default {
  ...dataAttributes,
  ...cart,
  ...misc,
};



// WEBPACK FOOTER //
// ./static/js/v0/constants/index.js